import { useEffect, useRef } from "react";
import { useAppDispatch } from "../../services/redux/hooks/use-dispatch";
import { useAppSelector } from "../../services/redux/hooks/use-selector";
import { AppAlert } from "../../shared/components/AppAlert";
import { AppSnackbar } from "../../shared/components/AppSnackbar";
import { selectNotifications } from "../../app/state/notificationSlice/selectors";
import { hideNotification } from "../../app/state/notificationSlice/slice";
import type { TNotificationObject } from "../../app/state/notificationSlice/types";
import { SlideTransition } from "./SlideTransition";
import styles from "./styles.module.css";

export const AppNotifications = () => {
  const dispatch = useAppDispatch();
  const notifications = useAppSelector(selectNotifications);
  const alertRef = useRef<HTMLDivElement>(null);

  const visibleNotifications = notifications.slice(0, 5);

  useEffect(() => {
    const timers = visibleNotifications.map((note: TNotificationObject) => {
      if (note.hideDuration != null) {
        return setTimeout(() => {
          dispatch(hideNotification(note.id));
        }, note.hideDuration);
      }
      return undefined;
    });

    return () => {
      timers.forEach((timer) => timer && clearTimeout(timer));
    };
  }, [visibleNotifications]);

  return (
    <>
      {visibleNotifications.map((note: TNotificationObject, index: number) => (
        <AppSnackbar
          key={note.id}
          open={true}
          TransitionComponent={SlideTransition}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          style={{
            top: `${50 + index * ((alertRef.current?.clientHeight ?? 56) + 6)}px`,
          }}
        >
          <AppAlert
            ref={alertRef}
            severity={note.type}
            alertType={note.type}
            message={note.message}
            onClose={() => {
              dispatch(hideNotification(note.id));
            }}
            title={note.title}
          />
        </AppSnackbar>
      ))}
    </>
  );
};
